export function parseBookingOrderId(id: string): number | string | undefined {
  if (/^[1-9]\d*$/.test(id) && Number.isSafeInteger(Number(id))) {
    return Number(id)
  }
  if (/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(id)) {
    return id
  }
}
